import { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

const languages = [
  { code: 'en', label: 'EN' },
  { code: 'es', label: 'ES' },
  { code: 'de', label: 'DE' },
];

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  const currentLang = languages.find((l) => l.code === i18n.language) || languages[0];

  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  const handleChange = (code: string) => {
    i18n.changeLanguage(code);
    setOpen(false);
  };

  return (
    <div ref={ref} className="relative">
      <button
        onClick={() => setOpen(!open)}
        className="flex items-center gap-1 text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap cursor-pointer"
        aria-label="Change language"
      >
        <span className="w-5 h-5 flex items-center justify-center">
          <i className="ri-global-line text-base"></i>
        </span>
        <span>{currentLang.label}</span>
        <span className="w-4 h-4 flex items-center justify-center">
          <i className={`ri-arrow-down-s-line text-xs transition-transform duration-200 ${open ? 'rotate-180' : ''}`}></i>
        </span>
      </button>

      {open && (
        <div className="absolute right-0 mt-2 bg-background-50 border border-background-200 rounded-md shadow-lg z-50 py-1 min-w-[80px]">
          {languages.map((lang) => (
            <button
              key={lang.code}
              onClick={() => handleChange(lang.code)}
              className={`w-full text-left px-3 py-2 text-sm hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap ${
                i18n.language === lang.code ? 'text-primary-700 font-medium bg-primary-50' : 'text-foreground-700'
              }`}
            >
              {lang.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}